import React from 'react';
import ConsoleHand from '../Assets/console-hand.webp';
import Send from '../Assets/btn-send.webp';
import SendHover from '../Assets/btn-send-hover.webp';
import HomeLeftElement from '../Assets/home-left-elmnts.webp';
import HomeRightElement from '../Assets/home-right-elmnts.webp';


const Contact = () => {

  return (
    <main id="contact" className="relative overflow-x-hidden flex justify-center flex-col h-full">
      <img className="absolute bottom-[5%] right-[0%] w-[40%] lg:w-[25%]" src={HomeLeftElement} alt="Floating Element" />
      <img className="absolute bottom-[3%] left-[-4%] w-[40%] lg:w-[25%]" src={HomeRightElement} alt="Floating Element" />


      <div className="container mx-auto py-10 md:py-20 px-5 relative z-10 flex flex-col items-center ">
        <div className="relative flex flex-col md:max-w-[500px] lg:max-w-[600px] mx-auto w-full">
          <img className="absolute w-[100%] top-[5%] left-[92%] lg:left-[92%]" src={ConsoleHand} alt="Console Right Hand" />
          <img className="absolute w-[100%] top-[5%] right-[92%] lg:right-[92%] -scale-x-100" src={ConsoleHand} alt="Console Right Hand" />

          <div className="form relative z-1 bg-[#4f3878] rounded-[1.5rem] md:rounded-[2rem] pb-20 p-4 md:p-10 md:pr-[7rem] border-4 border-black">
            <div className="title md:absolute md:right-[8%] md:top-[10%]">
              <h1 data-text="Contact Us" className="text-shadow text-center text-[1.3rem] md:text-[3rem] font-russo uppercase text-white">Contact Us</h1>
            </div>
            <div className="bg-[#390b59] border-4 border-[#1e1e1e] p-2 md:p-5 rounded-xl">

              <div className="border-4 border-white screen p-3 md:p-5 lg:p-10 space-y-3 md:space-y-5">
                <div className="flex flex-col">
                  <label>Name</label>
                  <input type="text" name="name" />
                </div>

                <div className="flex flex-col">
                  <label>Email Address *</label>
                  <input type="email" name="email" />
                </div>

                <div className="flex flex-col">
                  <label>Who are you ?</label>
                  <input type="text" name="who" />
                </div>

                <div className="flex flex-col">
                  <label>Message</label>
                  <textarea name="message" rows="4" cols="50">

                  </textarea>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute w-[100px] lg:left-[90%] md:left-[88%] md:bottom-[5%] -translate-x-1/2 md:left-auto left-1/2 bottom-[0%]">
            <button className="btn-send cursor-pointer relative">
              <img src={Send} alt="Send" />
              <img className="selected" src={SendHover} alt="Send Hover" />
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;